import { Button, Paper, Stack, Typography } from "@mui/material";
import Login from "../../../../../../../../Components/Sidebar/partials/Login/Auth";
import { useState } from "react";

const DialogLogin = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLogin = () => {
    setIsOpen(true);
  };
  return (
    <Paper
      sx={{
        position: "absolute",
        // left: "0%",
        // transform: "translateX(50%)",
        top: "10%",
        zIndex: 1,
        padding: "24px",
      }}
    >
      <Stack gap={2}>
        <Typography variant="h3">Login required</Typography>
        <Typography variant="body3">
          To upload and use shapefiles you need to be logged in.
        </Typography>
        <Button
          fullWidth
          variant="outlined"
          sx={{
            backgroundColor: "#2D3648",
            color: "white",
            "&:hover": {
              backgroundColor: "#343e53ff",
              color: "white",
            },
          }}
          onClick={handleLogin}
        >
          Login or Create Account
        </Button>
      </Stack>
      <Login isOpen={isOpen} setIsOpen={setIsOpen} />
    </Paper>
  );
};

export default DialogLogin;
